
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DeviceIssueDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deviceIssueDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DeviceIssueFields"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"device"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DeviceBasicFields"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"laneSide"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LaneSideFields"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"image"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DeviceImageFields"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"lane"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LaneBasicFields"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"store"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StoreFields"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"retailer"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RetailerBasicFields"},"directives":[]}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pendingImage"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DeviceOperationFields"},"directives":[]}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"notes"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DeviceIssueNotesFields"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DeviceIssueStatusFields"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"subtype"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DeviceIssueSubtypeFields"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DeviceIssueTypeFields"},"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":1344}};
    doc.loc.source = {"body":"#import '../device/DeviceBasicFieldsFragment.gql'\n#import '../device_image/DeviceImageFieldsFragment.gql'\n#import '../device_issue_note/DeviceIssueNotesFieldsFragment.gql'\n#import '../device_operation/DeviceOperationFieldsFragment.gql'\n#import '../lane/LaneBasicFieldsFragment.gql'\n#import '../lane_side/LaneSideFieldsFragment.gql'\n#import '../retailer/RetailerBasicFieldsFragment.gql'\n#import '../store/StoreFieldsFragment.gql'\n#import './DeviceIssueFieldsFragment.gql'\n#import './DeviceIssueStatusFieldsFragment.gql'\n#import './DeviceIssueSubtypeFieldsFragment.gql'\n#import './DeviceIssueTypeFieldsFragment.gql'\n\nquery DeviceIssueDetails($id: Int!) {\n  deviceIssueDetails(id: $id) {\n    ...DeviceIssueFields\n\n    device {\n      ...DeviceBasicFields\n\n      laneSide {\n        ...LaneSideFields\n\n        image {\n          ...DeviceImageFields\n        }\n\n        lane {\n          ...LaneBasicFields\n\n          store {\n            ...StoreFields\n\n            retailer {\n              ...RetailerBasicFields\n            }\n          }\n        }\n\n        pendingImage {\n          ...DeviceOperationFields\n        }\n      }\n    }\n\n    notes {\n      ...DeviceIssueNotesFields\n    }\n\n    status {\n      ...DeviceIssueStatusFields\n    }\n\n    subtype {\n      ...DeviceIssueSubtypeFields\n\n      type {\n        ...DeviceIssueTypeFields\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require('../device/DeviceBasicFieldsFragment.gql').definitions));
doc.definitions = doc.definitions.concat(unique(require('../device_image/DeviceImageFieldsFragment.gql').definitions));
doc.definitions = doc.definitions.concat(unique(require('../device_issue_note/DeviceIssueNotesFieldsFragment.gql').definitions));
doc.definitions = doc.definitions.concat(unique(require('../device_operation/DeviceOperationFieldsFragment.gql').definitions));
doc.definitions = doc.definitions.concat(unique(require('../lane/LaneBasicFieldsFragment.gql').definitions));
doc.definitions = doc.definitions.concat(unique(require('../lane_side/LaneSideFieldsFragment.gql').definitions));
doc.definitions = doc.definitions.concat(unique(require('../retailer/RetailerBasicFieldsFragment.gql').definitions));
doc.definitions = doc.definitions.concat(unique(require('../store/StoreFieldsFragment.gql').definitions));
doc.definitions = doc.definitions.concat(unique(require('./DeviceIssueFieldsFragment.gql').definitions));
doc.definitions = doc.definitions.concat(unique(require('./DeviceIssueStatusFieldsFragment.gql').definitions));
doc.definitions = doc.definitions.concat(unique(require('./DeviceIssueSubtypeFieldsFragment.gql').definitions));
doc.definitions = doc.definitions.concat(unique(require('./DeviceIssueTypeFieldsFragment.gql').definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["DeviceIssueDetails"] = oneQuery(doc, "DeviceIssueDetails");
        



//////////////////
// WEBPACK FOOTER
// ./src/graphql/device_issue/DeviceIssueDetailsQuery.gql
// module id = wjHl
// module chunks = 87